import { render, staticRenderFns } from "./opportunity_with_us.vue?vue&type=template&id=07ff4be2&scoped=true&"
import script from "./opportunity_with_us.vue?vue&type=script&lang=js&"
export * from "./opportunity_with_us.vue?vue&type=script&lang=js&"
import style0 from "./opportunity_with_us.vue?vue&type=style&index=0&id=07ff4be2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ff4be2",
  null
  
)

export default component.exports